import { styled } from "@mui/material/styles";

const PageContainer = styled("div")(() => ({
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  height: "100%", // TODO: figure out extra scroll bar
}));

export default PageContainer;
